export function setFocus($element) {
	$element = $element || document.body

	// NOTE: if I need to repair any bugs, see:
	// https://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus

	// var xPos = window.scrollX
	// var yPos = window.scrollY
	const $$focusable = $element.querySelectorAll('a[href], button, [role="button"], [tabindex]:not([tabindex="-1"])')

	if ($$focusable.length) {
		$$focusable[0].focus()
	}
	// window.scrollTo(xPos, yPos)

}
